export interface FormFieldFormTemplateMappingSource {
  type: 'form_field'
  path: string
  option?: string
}

export const VariableFormTemplateMappingSourceId = {
  USER_NAME: 'user_name',
  SESSION_STARTED_AT: 'session_started_at',
  SESSION_FINISHED_AT: 'session_finished_at',
  CURRENT_DATE: 'current_date',
  CURRENT_DATE_TIME: 'current_date_time',
} as const

export type VariableFormTemplateMappingSourceId = (typeof VariableFormTemplateMappingSourceId)[keyof typeof VariableFormTemplateMappingSourceId]

export interface VariableFormTemplateMappingSource {
  type: 'variable'
  id: VariableFormTemplateMappingSourceId
}

export type FormTemplateMappingSource = FormFieldFormTemplateMappingSource | VariableFormTemplateMappingSource

export interface FormTemplateMappingTargetSchema {
  type: string
  const?: string
}

export interface FormTemplateMappingPdfFormControlTarget {
  id: string
  parentId?: string
  type: 'pdf_form_control'
  name: string
  schema: FormTemplateMappingTargetSchema
}

export type FormTemplateMappingTarget = FormTemplateMappingPdfFormControlTarget

export interface FormTemplate {
  id: string
  name: string
  scorecardId: string
  fileId: string
  targets: FormTemplateMappingTarget[]
  mapping: Record<string, FormTemplateMappingSource>
}

export interface FormTemplateMappingFormValues {
  mapping: Record<string, FormTemplateMappingSource>
}

export interface FormTemplatePreview {
  targets: FormTemplateMappingTarget[]
}
